import { Grid, TextField, Typography } from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const CorreoOriginal = () => {
  const { proyecto, setProyecto } = useProyecto();
  const { setPromptData, promptData } = useActividadesContext();

  const handleCorreoOriginal = (event) => {
    const { value } = event.target;
    setProyecto({ ...proyecto, correoOriginal: value });
    setPromptData((prevData) => ({
      ...prevData,
      correoOriginal: value,
    }));
  };

  return (
    <Grid xs={12} lg={12} md={12}>
      <Typography
        id="modal-modal-title"
        sx={{
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
          color: "#336B87",
        }}
      >
        Correo original para responder *
      </Typography>

      <TextField
        required
        id="contexto"
        placeholder="Copia y pega el correo que deseas responder"
        name="contexto"
        multiline="true"
        rows={4}
        fullWidth
        autoComplete="given-name"
        variant="outlined"
        value={promptData.correoOriginal}
        onChange={handleCorreoOriginal}
        InputProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            mb: 3,
            fontFamily: "montserrat",
            fontSize: "0.75rem",
            color: "#005559",
            "&::placeholder": {
              color: "#005559",
            },
            "&:before": {
              borderBottomColor: "#005559",
            },
            "&:after": {
              borderBottomColor: "#005559",
            },
          },
        }}
      />
    </Grid>
  );
};

export default CorreoOriginal;
